/*
 * Local mode detection. Activated by VITE_LOCAL=true in .env.local OR
 * ?local=1 on the URL (sticky for the session via sessionStorage).
 * See IMPLEMENTATION_PLAN.md §7 "Phase 7 — Local mode".
 */

const SESSION_KEY = 'studio-v2.local-session';

let cached: boolean | null = null;

export function isLocalMode(): boolean {
  if (cached !== null) return cached;
  if (import.meta.env.VITE_LOCAL === 'true') {
    cached = true;
    return true;
  }
  if (typeof window !== 'undefined') {
    const url = new URL(window.location.href);
    if (url.searchParams.get('local') === '1') {
      sessionStorage.setItem(SESSION_KEY, '1');
      cached = true;
      return true;
    }
    if (sessionStorage.getItem(SESSION_KEY) === '1') {
      cached = true;
      return true;
    }
  }
  cached = false;
  return false;
}

export function clearLocalModeSession(): void {
  if (typeof window !== 'undefined') {
    sessionStorage.removeItem(SESSION_KEY);
  }
  cached = null;
}
